import React from 'react';
import {Spin} from 'antd';
import _ from 'lodash';

import {WeaTools} from 'ecCom';

class Element extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        };
        this.onLoadModule = this.onLoadModule.bind(this);
    }

    componentWillMount() {
        this.onLoadModule(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isEqual(this.props, nextProps)) {
            this.onLoadModule(nextProps);
        }
    }

    render() {
        const {loading} = this.state;
        const {isSetting, item = {}} = this.props;
        const {id, content = {}} = item;
        const {module, component} = content;

        if (loading) {
            return (
                <Spin spinning={loading}>
                    <div style={{width: '100%', height: '100%'}}/>
                </Spin>
            )
        } else {
            if (module && window[module] && window[module]['com'] && window[module]['com'][component]) {
                const Content = window[module]['com'][component];
                return <Content {...this.props} isSetting={isSetting} id={id} eid={id} params={{id, eid: id}} item={item}/>;
            } else {
                return <div style={{width: '100%', height: '100%', backgroundColor: '#fff'}}/>;
            }
        }
    }

    onLoadModule(props = {}) {
        const {item = {}} = props;
        const {content = {}} = item;
        const {id, module} = content;

        if (id && module && !window[module]) {
            this.setState({loading: true});
            WeaTools.loadDevModules(id, module).then(() => {
                const _interval = window.setInterval(() => {
                    if (window[module]) {
                        window.clearInterval(_interval);
                        this.setState({loading: false});
                    }
                }, 100);
            });
        }
    }
}

export default Element;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-portal-layout/Element.js